
import { CarehomeDto } from "../../../dto/CarehomeDto";

import { IFormElementController, FormElementController, FormPageValidator, FormElementValidator, StringValidators } from './../../../scripts/formcontrols'


export class CarehomeDetailController extends FormPageValidator {

    public name: FormElementController<string>;

    constructor(carehomeDto : CarehomeDto) {
        super();

        var nameValidator = new FormElementValidator<string>(true);
        this.name = new FormElementController<string>("Name", carehomeDto.name, nameValidator);
        

        this.addValidators(nameValidator);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/carehome/details/carehome-detail-controller.ts